/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_TextInputs */



/**
* | output |
* | --- |
* | "No text" |
*
* @param {Compare_Event_Groups_No_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_text = /** @type {((inputs?: Compare_Event_Groups_No_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст отсутствует")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストなし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई पाठ नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem texto")
	return /** @type {LocalizedString} */ ("No text")
});